import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Requests an initial option load when the collection is ready, then reloads
 * whenever the records context changes.
 */
export const loadOptionsOnContextChange = store.effects.create(
  <TTypeParams extends Plugin.TypeParams>(
    feature: Plugin<TTypeParams>['feature'],
    plugin: Plugin<TTypeParams>,
  ) =>
    plugin.collection.ready$.pipe(
      rxjs.map(() => 'DimensionFilter.Collection.Ready'),
      rxjs.concatWith(
        plugin.collection.feature.actions.changeContext.observe(),
      ),
      rxjs.map(source => feature.actions.loadOptions.from(source).create()),
    ),
)
